// extracted by mini-css-extract-plugin
export default {"errorMessage":"Switcher_errorMessage__e0Q8+","switcher":"Switcher_switcher__s1gGG"};